/* eslint-disable */
import throwI18nInvalidKeyLengthError from '../../../Errors/I18n/I18nInvalidKeyLength.error';
import throwI18nInvalidKeyTypeError from '../../../Errors/I18n/I18nInvalidKeyType.error';
import isString from '../../Is/String/IsString.support';

/**
 * Determine if a provided `key` is indeed a valid `key`
 * @export
 * @param {string} key The `key` to check
 * @returns {boolean} Whether or not the provided `key` is indeed valid
 */
const i18nValidateKey = (key) => {
  if (!isString(key)) {
    return throwI18nInvalidKeyTypeError(key);
  }
  const newKey = key.trim();
  if (newKey.length === 0) {
    return throwI18nInvalidKeyLengthError(newKey);
  }
  return true;
};

export default i18nValidateKey;
